var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFacebook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,7.7C118.9,7.7,7.7,118.9,7.7,256S118.9,504.3,256,504.3S504.3,393.1,504.3,256S393.1,7.7,256,7.7z M362.7,159c-5.6-0.6-15.1-0.9-27.1-0.9c-38.3,0-53.2,14.5-53.2,52.3v25.3h76.5l-13.2,71.6h-63.3V463h-84.9V307.3h-48.3v-71.6h48.3 v-30.8c0-79.7,36.1-116.6,114.3-116.6c14.8,0,40.4,2.9,50.9,5.8V159z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFacebook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Facebook.76a7633d16d73fd588b43692c42d2736.svg";